import { SendSalesEmailFromLandingBodyDto, SupportService } from 'app/API';
import type { TCall } from './types/TCall';

type TParams = {
  call: TCall;
  requestBody: SendSalesEmailFromLandingBodyDto;
};

export const sendSalesEmail = ({ call, requestBody }: TParams) =>
  call(() => SupportService.sendSalesEmailFromLanding({ requestBody }));
